import { render, staticRenderFns } from "./TabTwilight.vue?vue&type=template&id=2a22d85d&scoped=true"
import script from "./TabTwilight.vue?vue&type=script&lang=js"
export * from "./TabTwilight.vue?vue&type=script&lang=js"
import style0 from "./TabTwilight.vue?vue&type=style&index=0&id=2a22d85d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a22d85d",
  null
  
)

export default component.exports